const t = {
  horizontal: {
    width: "100%",
    height: "1px"
  },
  vertical: {
    width: "1px",
    height: "100%"
  }
};
export {
  t as directionToStylesMap
};
